import { render, staticRenderFns } from "./messageMailboxes.vue?vue&type=template&id=4b6edd70&scoped=true"
import script from "./messageMailboxes.vue?vue&type=script&lang=js"
export * from "./messageMailboxes.vue?vue&type=script&lang=js"
import style0 from "./messageMailboxes.vue?vue&type=style&index=0&id=4b6edd70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6edd70",
  null
  
)

export default component.exports